import { Formik } from "formik";
import * as Yup from "yup";
import formimg from "../Forms/Performance-Appraisal-Templates-1-1013x439 1.svg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import React, { useState, useEffect, useRef } from "react";
import { baseURL } from "../../config";

function GradeForm() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [showToast, setShowToast] = useState(false);

  const navigate = useNavigate();
  const usernameRef = useRef(null);

  const handleSubmit = async (values) => {
    setFormData(values); // Store form data before displaying the modal
    setShowModal(true); // Show the confirmation modal
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleConfirmSubmit = async () => {
    try {
      const response = await fetch(`${baseURL}/addgrade`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setFormData(null);
        setShowModal(false);
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
          navigate("/createTemplateTab");
        }, 3000);

        // window.location.href = "/createTemplateTab";
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          gradename: "",
          description: "",
        }}
        validationSchema={Yup.object({
          gradename: Yup.string().required("Grade name is required"),
          description: Yup.string().required("Skill level is required"),
        })}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <div className="container">
            <h4 className="text-start  pb-2">Create Grade</h4>
            <div className="col-lg-12  mt-1 m-5">
              <form noValidate onSubmit={handleSubmit}>
                <div className="row h-75">
                  <div className="col-lg-5 ">
                    <label className="formlabel">
                      Grade Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${
                        touched.gradename && errors.gradename
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Enter title"
                      name="gradename"
                      value={values.gradename}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.gradename && errors.gradename ? (
                      <div className="text-danger">{errors.gradename}</div>
                    ) : null}
                  </div>

                  <div className="col-lg-5 ml-5">
                    <label>Description</label>
                    <textarea
                      className={`form-control ${
                        touched.description && errors.description
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Enter description"
                      name="description"
                      value={values.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    ></textarea>
                    {touched.description && errors.description ? (
                      <div className="text-danger">{errors.description}</div>
                    ) : null}
                  </div>
                </div>
                <div className="col-lg-11 text-end mt-4 pb-3">
                  <Button
                    className="border-0 mt-2 p-1 btn-#8d3523 savebtn"
                    type="submit"
                  >
                    Save
                  </Button>
                  <a href="/createtemplate" className="text-decoration-none ">
                    {" "}
                    <Button
                      type="button"
                      className="btn cancelbtn ml-2"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </Button>
                  </a>
                </div>
              </form>
            </div>
          </div>
        )}
      </Formik>

      {/* Confirmation Modal */}
      <div className="col-lg-12">
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Do You Want to Confirm the changes?</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleConfirmSubmit}>
              Yes
            </Button>
            <Button variant="secondary" onClick={handleCloseModal}>
              No
            </Button>
          </Modal.Footer>
        </Modal>
        <div>
          <ToastContainer position="bottom-end" className="p-3">
            <Toast
              onClose={() => setShowToast(false)}
              show={showToast}
              delay={3000}
              autohide
              className="bg-success text-white"
            >
              <Toast.Header>
                <span className="me-2">✔️</span> {/* Unicode tick mark */}
                <strong className="me-auto">Notification</strong>
              </Toast.Header>
              <Toast.Body>Success!, data updated successfully!</Toast.Body>
            </Toast>
          </ToastContainer>
        </div>
      </div>
    </>
  );
}

export default GradeForm;
